// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width: 768px) and (max-width:991px){
    .top-nav{
        padding-left: 54px;
        padding-right: 54px;
    }
    .top-nav a{
        font-size: 14px!important;
        padding: 0;
        margin-left: 24px;
    }
   html[dir='ltr'] .language-btn{
    margin-left: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/layout/components/TopNav.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,UAAU;QACV,iBAAiB;IACrB;GACD;IACC,iBAAiB;IACjB;AACJ","sourcesContent":["@media(min-width: 768px) and (max-width:991px){\n    .top-nav{\n        padding-left: 54px;\n        padding-right: 54px;\n    }\n    .top-nav a{\n        font-size: 14px!important;\n        padding: 0;\n        margin-left: 24px;\n    }\n   html[dir='ltr'] .language-btn{\n    margin-left: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
